// import React, { useEffect, useState } from 'react';
// import { Grid, Box, Typography, Button } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { styled } from '@mui/material/styles';
// import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
// import './Slideshow.css';
// import ContanierHeading from '../../../../../components/component/resused-component/ContanierHeading';

// // Define a type for the Dot component props
// interface DotProps {
// 	active: boolean;
// 	onClick: () => void;
// }

// // Styled Components for Reusability
// const SlideshowContainer = styled(Box)(() => ({
// 	position: 'relative',
// 	width: '100%',
// 	overflow: 'hidden',
// }));

// const Slide = styled(Box)(() => ({
// 	width: '100%',
// 	position: 'relative',
// 	overflow: 'hidden',
// }));

// const DotsContainer = styled(Box)(() => ({
// 	textAlign: 'center',
// 	marginTop: '10px',
// 	display: 'flex',
// 	justifyContent: 'center',
// 	alignItems: 'center',
// }));

// const Dot = styled('span')<DotProps>(({ active }) => ({
// 	height: active ? '15px' : '10px',
// 	width: active ? '15px' : '10px',
// 	margin: '0 4px',
// 	backgroundColor: active ? '#CD3131' : '#FFAFA5', // Active and inactive colors
// 	borderRadius: '50%',
// 	display: 'inline-block',
// 	transition: 'background-color 0.6s ease, box-shadow 0.6s ease', // Smooth transition for both properties
// 	cursor: 'pointer',
// 	boxShadow: active ? '0px 0px 0px 2px #CD3131' : 'none', // Outline effect for active dot
// }));

// const Slideshow = () => {
// 	const [slideIndex, setSlideIndex] = useState(0);
// 	const navigate = useNavigate();
// 	const handleBookNow = () => {
// 		navigate('/menu'); // Navigate to the /menu route
// 	};

// 	const slides = [
// 		{
// 			title: 'Ayutha Poojai and Deebavali Special',
// 			src: '/assets/festival-special/sweet.png',
// 			titleHeader: 'Sweets',
// 			description: 'Giftbox Packing Available for 500grams and 1kg',
// 		},
// 		{
// 			title: 'Ayutha Poojai and Deebavali Special',
// 			src: '/assets/festival-special/laddu.png',
// 			titleHeader: 'Ladoo',
// 			description: 'Giftbox Packing Available for 500grams and 1kg',
// 		},
// 		{
// 			title: 'Ayutha Poojai and Deebavali Special',
// 			src: '/assets/festival-special/mysore.png',
// 			titleHeader: 'Mysore Pak',
// 			description: 'Giftbox Packing Available for 500grams and 1kg',
// 		},
// 	];

// 	useEffect(() => {
// 		const timer = setTimeout(() => {
// 			setSlideIndex((prevIndex) => (prevIndex + 1) % slides.length);
// 		}, 5000); // 5 seconds
// 		return () => clearTimeout(timer);
// 	}, [slideIndex, slides.length]);

// 	return (
// 		<Box sx={{ position: 'relative', mb: 4, mt: 4 }}>
// 			<Grid container className="mb-3">
// 				<Grid size={{ md: 2 }} sx={{ display: { sm: 'none', md: 'block' } }} />
// 				<Grid size={{ xs: 12, sm: 12, md: 8 }}>
// 					<Box
// 						sx={{
// 							display: 'flex',
// 							justifyContent: 'center',
// 							alignItems: 'center',
// 							flexDirection: 'column',
// 						}}
// 					>
// 						<ContanierHeading name="Festival Special" />
// 						<Typography
// 							variant="subtitle2"
// 							color="secondary"
// 							width={'inherit'}
// 							textAlign={'center'}
// 							maxWidth={'inherit'}
// 						>
// 							We undertake bulk sweet orders for Ayudha Pooja & Deepavali Festivals
// 							for individuals and corporate Customers. We care to take the Customers
// 							Delight and Offer the best price for sweets & snacks. Place an order for
// 							sweets as you wish and we will deliver it to you at your door step. We
// 							request you to place your orders at least 10-15 days before deepavali/
// 							ayudha-pooja to ensure hassle free delivery. We also welcome corporate
// 							companies for bulk sweet orders at an attractive price. Call us for more
// 							information about the sweets and price.
// 						</Typography>
// 					</Box>
// 				</Grid>
// 			</Grid>
// 			<SlideshowContainer>
// 				<Grid
// 					container
// 					spacing={2}
// 					sx={{
// 						height: '100%',
// 						display: 'flex',
// 						justifyContent: 'center',
// 						alignItems: { xs: 'normal', sm: 'normal', md: 'normal', lg: 'center' },
// 					}}
// 				>
// 					{slides.length > 1 && (
// 						<Grid
// 							size={{ xs: 12, sm: 12, md: 12, lg: 2 }}
// 							sx={{
// 								// display: { xs: 'none', sm: 'none', md: 'block' },
// 								display: { xs: 'none', lg: 'block' },
// 								overflow: 'hidden',
// 							}}
// 						>
// 							<Slide sx={{ transform: 'scale(0.9)', opacity: 0.7 }}>
// 								<Box
// 									sx={{
// 										backgroundColor:
// 											slideIndex % 2 !== 0 ? '#F3274C26' : '#E2E4FE',
// 										transition:
// 											'background-color 0.6s ease, box-shadow 0.6s ease',
// 										minHeight: '300px',
// 										maxHeight: '500px',
// 										maxWidth: '500px',
// 										padding: '10px',
// 										borderRadius: '0px 100% 100% 0px',
// 										display: 'flex',
// 										alignItems: 'center',
// 										justifyContent: 'center',
// 									}}
// 								>
// 									<img
// 										src={
// 											slides[(slideIndex - 1 + slides.length) % slides.length]
// 												.src
// 										}
// 										key={
// 											slides[(slideIndex - 1 + slides.length) % slides.length]
// 												.src
// 										}
// 										alt="Next"
// 										style={{
// 											width: '100%',
// 											height: 'auto',
// 											objectFit: 'contain',
// 											opacity: 0,
// 											transition:
// 												'opacity 1s ease-in-out, transform 1s ease-in-out', // Fading effect for image transition
// 										}}
// 										onLoad={(e) => {
// 											(e.target as HTMLImageElement).style.opacity = '1'; // Fade in the image when it has loaded
// 										}}
// 									/>
// 								</Box>
// 							</Slide>
// 						</Grid>
// 					)}

// 					<Grid
// 						size={{
// 							xs: slides.length > 1 ? 8 : 12,
// 							sm: slides.length > 1 ? 8 : 12,
// 							md: slides.length > 1 ? 8 : 12,
// 						}}
// 						sx={{ height: 'inherit' }}
// 					>
// 						<Slide sx={{ display: 'flex', height: 'inherit' }}>
// 							<Box
// 								sx={{
// 									width: '100%',
// 									height: '100%',
// 									display: 'flex',
// 									flexDirection: { xs: 'column-reverse', sm: 'row' },
// 									padding: '10px',
// 									minHeight: '300px',
// 									borderRadius: '322.92px',
// 									backgroundColor: slideIndex % 2 === 0 ? '#F3274C26' : '#E2E4FE',
// 									transition: 'background-color 0.6s ease, box-shadow 0.6s ease',
// 								}}
// 							>
// 								<Box
// 									sx={{
// 										p: 5,
// 										ps: 10,
// 										width: { xs: '100%', sm: '50%' },
// 										display: 'flex',
// 										justifyContent: 'center',
// 										alignItems: 'center',
// 									}}
// 								>
// 									<div style={{ textAlign: 'start' }}>
// 										<Typography variant="body1" gutterBottom color="#222222">
// 											{slides[slideIndex].title}
// 										</Typography>
// 										<Typography
// 											variant="h4"
// 											gutterBottom
// 											color="#222222"
// 											fontWeight={800}
// 										>
// 											{slides[slideIndex].titleHeader}
// 										</Typography>
// 										<Typography variant="body1" color="#434343">
// 											{slides[slideIndex].description}
// 										</Typography>
// 										<Button
// 											variant="contained"
// 											color="primary"
// 											style={{ marginTop: '20px' }}
// 											endIcon={<ArrowRightAltIcon />}
// 											onClick={handleBookNow}
// 										>
// 											Book Now
// 										</Button>
// 									</div>
// 								</Box>
// 								<Box
// 									sx={{
// 										width: { xs: '100%', sm: '50%' },
// 										display: 'flex',
// 										justifyContent: 'center',
// 									}}
// 								>
// 									<img
// 										src={slides[slideIndex].src}
// 										key={slides[slideIndex].src}
// 										alt={`Slide ${slideIndex + 1}`}
// 										style={{
// 											width: '200px',
// 											height: '200px',
// 											opacity: 0,
// 											transition:
// 												'opacity 1s ease-in-out, transform 1s ease-in-out', // Fading effect for image transition
// 										}}
// 										onLoad={(e) => {
// 											(e.target as HTMLImageElement).style.opacity = '1'; // Fade in the image when it has loaded
// 										}}
// 									/>
// 								</Box>
// 							</Box>
// 						</Slide>
// 					</Grid>

// 					{slides.length > 1 && (
// 						<Grid
// 							size={{ xs: 12, md: 12, lg: 2 }}
// 							sx={{
// 								// display: { xs: 'none', sm: 'none', md: 'block' },
// 								display: { xs: 'none', lg: 'block' },
// 								overflow: 'hidden',
// 							}}
// 						>
// 							<Slide sx={{ transform: 'scale(0.9)', opacity: 0.7 }}>
// 								<Box
// 									sx={{
// 										backgroundColor:
// 											slideIndex % 2 !== 0 ? '#F3274C26' : '#E2E4FE',
// 										minHeight: '300px',
// 										maxHeight: '500px',
// 										maxWidth: '500px',
// 										padding: '10px',
// 										borderRadius: '100% 0px 0px 100%',
// 										display: 'flex',
// 										alignItems: 'center',
// 										justifyContent: 'center',
// 										transition:
// 											'background-color 0.6s ease, box-shadow 0.6s ease',
// 									}}
// 								>
// 									{/* <img
// 										src={slides[(slideIndex + 1) % slides.length].src}
// 										alt="Next"
// 										style={{
// 											width: '100%',
// 											height: 'auto',
// 											objectFit: 'contain',
// 										}}
// 									/> */}
// 									<img
// 										key={slides[(slideIndex + 1) % slides.length].src} // Forces a re-render when src changes
// 										src={slides[(slideIndex + 1) % slides.length].src}
// 										alt="Next"
// 										style={{
// 											width: '100%',
// 											height: 'auto',
// 											objectFit: 'contain',
// 											opacity: 0,
// 											transition:
// 												'opacity 1s ease-in-out, transform 1s ease-in-out', // Fading effect for image transition
// 										}}
// 										onLoad={(e) => {
// 											(e.target as HTMLImageElement).style.opacity = '1'; // Fade in the image when it has loaded
// 										}}
// 									/>
// 								</Box>
// 							</Slide>
// 						</Grid>
// 					)}
// 				</Grid>
// 			</SlideshowContainer>

// 			<DotsContainer>
// 				{slides.map((_, index) => (
// 					<Dot
// 						key={index}
// 						active={slideIndex === index}
// 						onClick={() => setSlideIndex(index)}
// 					/>
// 				))}
// 			</DotsContainer>
// 		</Box>
// 	);
// };

// export default Slideshow;
// ===============================================================================================================================================
// ===============================================================================================================================================
// ===============================================================================================================================================
// ===============================================================================================================================================
// ===============================================================================================================================================
// ===============================================================================================================================================
// ===============================================================================================================================================
// ===============================================================================================================================================
// ===============================================================================================================================================
// import React, { useEffect, useState } from 'react';
// import { Grid, Box, Typography, Button } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { styled } from '@mui/material/styles';
// import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
// import './Slideshow.css';
// import ContanierHeading from '../../../../../components/component/resused-component/ContanierHeading';

// // Define a type for the Dot component props
// interface DotProps {
// 	active: boolean;
// 	onClick: () => void;
// }

// // Styled Components for Reusability
// const SlideshowContainer = styled(Box)(() => ({
// 	position: 'relative',
// 	width: '100%',
// 	overflow: 'hidden',
// }));

// const Slide = styled(Box)(() => ({
// 	width: '100%',
// 	position: 'relative',
// 	overflow: 'hidden',
// }));

// const DotsContainer = styled(Box)(() => ({
// 	textAlign: 'center',
// 	marginTop: '10px',
// 	display: 'flex',
// 	justifyContent: 'center',
// 	alignItems: 'center',
// }));

// const Dot = styled('span')<DotProps>(({ active }) => ({
// 	height: active ? '15px' : '10px',
// 	width: active ? '15px' : '10px',
// 	margin: '0 4px',
// 	backgroundColor: active ? '#CD3131' : '#FFAFA5', // Active and inactive colors
// 	borderRadius: '50%',
// 	display: 'inline-block',
// 	transition: 'background-color 0.6s ease, box-shadow 0.6s ease', // Smooth transition for both properties
// 	cursor: 'pointer',
// 	boxShadow: active ? '0px 0px 0px 2px #CD3131' : 'none', // Outline effect for active dot
// }));

// const Slideshow = () => {
// 	const [slideIndex, setSlideIndex] = useState(0);
// 	const navigate = useNavigate();
// 	const handleBookNow = () => {
// 		navigate('/menu'); // Navigate to the /menu route
// 	};

// 	const slides = [
// 		{
// 			title: 'Ayutha Poojai and Deebavali Special',
// 			src: '/assets/festival-special/sweet.png',
// 			titleHeader: 'Sweets',
// 			description: 'Giftbox Packing Available for 500grams and 1kg',
// 		},
// 		{
// 			title: 'Ayutha Poojai and Deebavali Special',
// 			src: '/assets/festival-special/laddu.png',
// 			titleHeader: 'Ladoo',
// 			description: 'Giftbox Packing Available for 500grams and 1kg',
// 		},
// 		{
// 			title: 'Ayutha Poojai and Deebavali Special',
// 			src: '/assets/festival-special/mysore.png',
// 			titleHeader: 'Mysore Pak',
// 			description: 'Giftbox Packing Available for 500grams and 1kg',
// 		},
// 	];

// 	useEffect(() => {
// 		const timer = setTimeout(() => {
// 			setSlideIndex((prevIndex) => (prevIndex + 1) % slides.length);
// 		}, 5000); // 5 seconds
// 		return () => clearTimeout(timer);
// 	}, [slideIndex, slides.length]);

// 	return (
// 		<Box sx={{ position: 'relative', mb: 4, mt: 4 }}>
// 			<Grid container className="mb-3">
// 				<Grid size={{ md: 2 }} sx={{ display: { sm: 'none', md: 'block' } }} />
// 				<Grid size={{ xs: 12, sm: 12, md: 8 }}>
// 					<Box
// 						sx={{
// 							display: 'flex',
// 							justifyContent: 'center',
// 							alignItems: 'center',
// 							flexDirection: 'column',
// 						}}
// 					>
// 						<ContanierHeading name="Festival Special" />
// 						<Typography
// 							variant="subtitle2"
// 							color="secondary"
// 							width={'inherit'}
// 							textAlign={'center'}
// 							maxWidth={'inherit'}
// 						>
// 							We undertake bulk sweet orders for Ayudha Pooja & Deepavali Festivals
// 							for individuals and corporate Customers. We care to take the Customers
// 							Delight and Offer the best price for sweets & snacks. Place an order for
// 							sweets as you wish and we will deliver it to you at your door step. We
// 							request you to place your orders at least 10-15 days before deepavali/
// 							ayudha-pooja to ensure hassle free delivery. We also welcome corporate
// 							companies for bulk sweet orders at an attractive price. Call us for more
// 							information about the sweets and price.
// 						</Typography>
// 					</Box>
// 				</Grid>
// 			</Grid>
// 			<SlideshowContainer>
// 				<Grid
// 					container
// 					spacing={2}
// 					sx={{
// 						height: '100%',
// 						display: 'flex',
// 						justifyContent: 'center',
// 						alignItems: { xs: 'normal', sm: 'normal', md: 'normal', lg: 'center' },
// 					}}
// 				>
// 					<Grid
// 						size={{
// 							xs: slides.length > 1 ? 8 : 12,
// 							sm: slides.length > 1 ? 8 : 12,
// 							md: slides.length > 1 ? 8 : 12,
// 						}}
// 						sx={{ height: 'inherit' }}
// 					>
// 						<Slide sx={{ display: 'flex', height: 'inherit' }}>
// 							<Box
// 								sx={{
// 									width: '100%',
// 									height: '100%',
// 									display: 'flex',
// 									flexDirection: { xs: 'column-reverse', sm: 'row' },
// 									padding: '10px',
// 									minHeight: '300px',
// 									borderRadius: '322.92px',
// 									backgroundColor: slideIndex % 2 === 0 ? '#F3274C26' : '#E2E4FE',
// 									transition: 'background-color 0.6s ease, box-shadow 0.6s ease',
// 								}}
// 							>
// 								<Box
// 									sx={{
// 										p: 5,
// 										ps: 10,
// 										width: { xs: '100%', sm: '50%' },
// 										display: 'flex',
// 										justifyContent: 'center',
// 										alignItems: 'center',
// 									}}
// 								>
// 									<div style={{ textAlign: 'start' }}>
// 										<Typography variant="body1" gutterBottom color="#222222">
// 											{slides[slideIndex].title}
// 										</Typography>
// 										<Typography
// 											variant="h4"
// 											gutterBottom
// 											color="#222222"
// 											fontWeight={800}
// 										>
// 											{slides[slideIndex].titleHeader}
// 										</Typography>
// 										<Typography variant="body1" color="#434343">
// 											{slides[slideIndex].description}
// 										</Typography>
// 										<Button
// 											variant="contained"
// 											color="primary"
// 											style={{ marginTop: '20px' }}
// 											endIcon={<ArrowRightAltIcon />}
// 											onClick={handleBookNow}
// 										>
// 											Book Now
// 										</Button>
// 									</div>
// 								</Box>
// 								<Box
// 									sx={{
// 										width: { xs: '100%', sm: '50%' },
// 										display: 'flex',
// 										justifyContent: 'center',
// 									}}
// 								>
// 									<img
// 										src={slides[slideIndex].src}
// 										key={slides[slideIndex].src}
// 										alt={`Slide ${slideIndex + 1}`}
// 										style={{
// 											width: '200px',
// 											height: '200px',
// 											opacity: 0,
// 											transition:
// 												'opacity 1s ease-in-out, transform 1s ease-in-out', // Fading effect for image transition
// 										}}
// 										onLoad={(e) => {
// 											(e.target as HTMLImageElement).style.opacity = '1'; // Fade in the image when it has loaded
// 										}}
// 									/>
// 								</Box>
// 							</Box>
// 						</Slide>
// 					</Grid>
// 				</Grid>
// 			</SlideshowContainer>

// 			<DotsContainer>
// 				{slides.map((_, index) => (
// 					<Dot
// 						key={index}
// 						active={slideIndex === index}
// 						onClick={() => setSlideIndex(index)}
// 					/>
// 				))}
// 			</DotsContainer>
// 		</Box>
// 	);
// };

// export default Slideshow;
// ===================================================================================================================
// ===================================================================================================================
// ===================================================================================================================
// ===================================================================================================================
// ===================================================================================================================
// ===================================================================================================================
// ===================================================================================================================
// ===================================================================================================================
// ===================================================================================================================
import React from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './Slideshow.css';
import ContanierHeading from '../../../../../components/component/resused-component/ContanierHeading';

// Styled Components for Reusability
const SlideshowContainer = styled(Box)(() => ({
	position: 'relative',
	width: '100%',
	overflow: 'hidden',
}));

const Slide = styled(Box)(() => ({
	width: '100%',
	position: 'relative',
	overflow: 'hidden',
}));

const Slideshow = () => {
	const navigate = useNavigate();
	const handleBookNow = () => {
		navigate('/menu'); // Navigate to the /menu route
	};

	const slides = [
		{
			title: 'Ayutha Poojai and Deebavali Special',
			src: '/assets/festival-special/sweet.png',
			titleHeader: 'Sweets',
			description: 'Giftbox Packing Available for 500grams and 1kg',
		},
		{
			title: 'Ayutha Poojai and Deebavali Special',
			src: '/assets/festival-special/laddu.png',
			titleHeader: 'Ladoo',
			description: 'Giftbox Packing Available for 500grams and 1kg',
		},
		{
			title: 'Ayutha Poojai and Deebavali Special',
			src: '/assets/festival-special/mysore.png',
			titleHeader: 'Mysore Pak',
			description: 'Giftbox Packing Available for 500grams and 1kg',
		},
		{
			title: 'Ayutha Poojai and Deebavali Special',
			src: '/assets/festival-special/walnut.png',
			titleHeader: 'Walnut',
			description: 'Giftbox Packing Available for 500grams and 1kg',
		},
		{
			title: 'Ayutha Poojai and Deebavali Special',
			src: '/assets/festival-special/badam-halwa.png',
			titleHeader: 'Badam Halwa',
			description: 'Giftbox Packing Available for 500grams and 1kg',
		},
		{
			title: 'Ayutha Poojai and Deebavali Special',
			src: '/assets/festival-special/pista-halwa.png',
			titleHeader: 'Pista Halwa',
			description: 'Giftbox Packing Available for 500grams and 1kg',
		},
	];

	return (
		<Box sx={{ position: 'relative', mb: 4, mt: 4 }}>
			<Grid container className="mb-3">
				<Grid size={{ md: 2 }} sx={{ display: { sm: 'none', md: 'block' } }} />
				<Grid size={{ xs: 12, sm: 12, md: 8 }}>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							flexDirection: 'column',
						}}
					>
						<ContanierHeading name="Festival Special" />
						<Typography
							variant="subtitle2"
							color="secondary"
							width={'inherit'}
							textAlign={'center'}
							maxWidth={'inherit'}
						>
							We undertake bulk sweet orders for Ayudha Pooja & Deepavali Festivals
							for individuals and corporate Customers. We care to take the Customers
							Delight and Offer the best price for sweets & snacks. Place an order for
							sweets as you wish and we will deliver it to you at your door step. We
							request you to place your orders at least 10-15 days before deepavali/
							ayudha-pooja to ensure hassle free delivery. We also welcome corporate
							companies for bulk sweet orders at an attractive price. Call us for more
							information about the sweets and price.
						</Typography>
					</Box>
				</Grid>
			</Grid>
			<SlideshowContainer>
				<Swiper
					spaceBetween={30}
					centeredSlides={true}
					slidesPerView={1}
					autoplay={{
						delay: 2500,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
					}}
					pagination={{
						clickable: true,
					}}
					navigation={true}
					modules={[Autoplay, Pagination, Navigation]}
					className="mySwiper"
					breakpoints={{
						// Define responsive breakpoints
						600: {
							slidesPerView: 1, // 1 slide per view for small screens
						},
						900: {
							slidesPerView: 2, // 2 slides per view for medium screens
						},
						1200: {
							slidesPerView: 2, // 3 slides per view for large screens
						},
					}}
				>
					{slides.map((slide, index) => (
						<SwiperSlide key={index}>
							<Slide>
								<Box
									sx={{
										width: { xs: '90%', md: '100%' },
										height: '100%',
										display: 'flex',
										flexDirection: { xs: 'column-reverse', sm: 'row' },
										padding: '10px 0px 0px 0px',
										minHeight: '300px',
										borderRadius: '322.92px',
										backgroundColor: index % 2 === 0 ? '#F3274C26' : '#E2E4FE',
										transition:
											'background-color 0.6s ease, box-shadow 0.6s ease',
										margin: 'auto',
									}}
								>
									<Box
										sx={{
											// p: 5,
											// ps: 10,
											width: { xs: '100%', sm: '50%' },
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											padding: { xs: '10px' },
											paddingLeft: { xs: '10px', md: '10%' },
											paddingBottom: { xs: '75px', sm: '0px' },
										}}
									>
										{/* <div style={{ textAlign: 'start' }}> */}
										<Box sx={{ textAlign: { xs: 'center', md: 'start' } }}>
											{/* <Typography
												variant="body1"
												gutterBottom
												color="#222222"
											>
												{slide.title}
											</Typography> */}
											<Typography
												variant="h4"
												gutterBottom
												color="#222222"
												fontWeight={800}
											>
												{slide.titleHeader}
											</Typography>
											<Typography
												variant="body1"
												color="#434343"
												sx={{ padding: { xs: '0px 5%', md: '0px' } }}
											>
												{slide.description}
											</Typography>
											<Button
												variant="contained"
												color="primary"
												style={{ marginTop: '20px' }}
												endIcon={<ArrowRightAltIcon />}
												onClick={handleBookNow}
											>
												{/* Explore our Menu */}
												{/* Get Quotation */}
												Explore Our Flavors
											</Button>
										</Box>
									</Box>
									<Box
										sx={{
											width: { xs: '100%', sm: '50%' },
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
										}}
									>
										<img
											src={slide.src}
											alt={`Slide ${index + 1}`}
											style={{
												width: '200px',
												height: '200px',
												opacity: 0,
												transition:
													'opacity 1s ease-in-out, transform 1s ease-in-out', // Fading effect for image transition
											}}
											onLoad={(e) => {
												(e.target as HTMLImageElement).style.opacity = '1'; // Fade in the image when it has loaded
											}}
										/>
									</Box>
								</Box>
							</Slide>
						</SwiperSlide>
					))}
				</Swiper>
			</SlideshowContainer>
		</Box>
	);
};

export default Slideshow;
